import { Components, switchClasses, Theme } from '@mui/material';

export function getMuiSwitch(theme: Theme): Components['MuiSwitch'] {
  return {
    styleOverrides: {
      root: ({ ownerState: { disabled } }) => ({
        padding: 0,
        borderRadius: 12, // hardcoded intentionally

        [`& > .${switchClasses.switchBase} + .${switchClasses.track}`]: {
          background: theme.palette.grey[100],
        },

        [`& > .${switchClasses.switchBase}.${switchClasses.checked} + .${switchClasses.track}`]:
          {
            background: disabled ? undefined : theme.palette.primary.main,
          },

        [`&:hover > .${switchClasses.switchBase} + .${switchClasses.track}`]: {
          background: disabled ? undefined : theme.palette.grey[200],
        },

        [`&:hover > .${switchClasses.switchBase}.${switchClasses.checked} + .${switchClasses.track}`]:
          {
            background: disabled ? undefined : theme.palette.primary.dark,
          },
      }),

      sizeSmall: {
        width: 32,
        height: 20,
      },

      sizeMedium: {
        width: 40,
        height: 24,
      },

      switchBase: ({ ownerState }) => ({
        '&&&': {
          padding: theme.spacing(0.5),

          [`&.${switchClasses.checked}`]: {
            transform: `translateX(${ownerState.size === 'small' ? 12 : 16}px)`,
          },
        },

        '&:active': {
          transform: 'unset',
        },

        '&, &:hover': {
          boxShadow: 'none',
        },
      }),

      thumb: ({ ownerState: { disabled } }) => ({
        background: disabled
          ? theme.palette.grey[400]
          : theme.palette.background.paper,

        '&, &:hover': {
          boxShadow: disabled
            ? 'none'
            : '0px 0px 5px rgba(31, 34, 38, 0.1), 0px 0px 15px rgba(31, 34, 38, 0.1)',
        },
      }),

      track: {
        '&&&&': {
          opacity: 1,
        },
      },
    },
  };
}
